<app-header-toolbar title="Helios Viewer"
                    [showBack]="false">
</app-header-toolbar>

<ion-content [scrollY]="false"
             [scrollX]="false">
    <div class="content-wrapper">
        <div class="actions-title">What would you like to do?</div>
        <div class="action-buttons-container">
            <app-action-button *ngIf="(auth.isAdmin$ | async) || (auth.isSuperAdmin$ | async)"
                               text="ADMIN"
                               icon="settings-outline"
                               routerLink="/admin">
            </app-action-button>

            <app-action-button *ngIf="(auth.isReviewer$ | async) || (auth.isAdmin$ | async)"
                               text="REVIEW FLIGHT"
                               icon="images-outline"
                               routerLink="/review/select">
            </app-action-button>

            <app-action-button *ngIf="(auth.isReviewer$ | async) || (auth.isAdmin$ | async)"
                               text="CROPPING"
                               icon="crop-outline"
                               routerLink="/cropping/select">
            </app-action-button>

            <app-action-button *ngIf="(auth.isViewer$ | async) || (auth.isAdmin$ | async)"
                               text="VIEW IMAGES"
                               icon="eye-outline"
                               routerLink="/view/selectview">
            </app-action-button>

            <app-action-button *ngIf="(auth.isInspector$ | async) || (auth.isAdmin$ | async) || (auth.isSuperAdmin$ | async)"
                               text="INSPECT IMAGES"
                               icon="search"
                               routerLink="/inspect/select">
            </app-action-button>

<!--            <app-action-button *ngIf="(auth.isAdmin$ | async) || (auth.isSuperAdmin$ | async)"-->
<!--                               text="VIEW REPORTS"-->
<!--                               icon="document-text-outline"-->
<!--                               routerLink="/reports">-->
<!--            </app-action-button>-->
        </div>
    </div>
</ion-content>
